import { Component, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage';
import { PatientService } from 'src/app/services/patient.service';
import { ToolService } from 'src/app/services/tool.service';


@Component({
  selector: 'app-prescription',
  templateUrl: './prescription.component.html',
  styleUrls: ['./prescription.component.scss'],
})
export class PrescriptionComponent implements OnInit {

  public data = [];

  constructor(private service : PatientService, private storage : Storage, private tool : ToolService) { }

  ngOnInit() {
    this.storage.get('prescription_items').then(val =>{
      if(val)
        this.data = val;
      else{
        this.service.GetPrescriptions().toPromise()
        .catch(err =>{
          if(err){
            return;
          }
        })
        .then(res =>{
          if(res){
            res.data.forEach(element => {
              element.Date = this.tool.ConvertToPersianDateTime(element.Date);
              this.data.push(element);
            });
            this.storage.set('prescription_items', this.data)
          }
        })
      }
    })
  }

  Refresh(ev){
    this.service.GetPrescriptions().toPromise()
    .catch(err =>{
      if(err){
        ev.target.complete();
        return;
      }
    })
    .then(res =>{
      if(res){
        this.data = [];
        res.data.forEach(element => {
          element.Date = this.tool.ConvertToPersianDateTime(element.Date);
          this.data.push(element);
        });
        this.storage.set('prescription_items', this.data).then(() => ev.target.complete());
      }
    })
  }

}
